import { Directive, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthCommonService } from 'avn/services/auth-app/auth-common.service';
import { Subscription } from 'rxjs';

// Shared provider log in (form, redirect param, authenticate + post login navigation) for WebNav and SignIn
@Directive()
export abstract class SignInBaseComponent implements OnInit, OnDestroy {
  protected fb = inject(FormBuilder);
  protected route = inject(ActivatedRoute);
  protected authCommonService = inject(AuthCommonService);

  readonly loading = signal(false);
  redirectUrl: string;

  signInForm = this.fb.group({
    email: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });

  protected subscriptions: Subscription[] = [];

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params: any) => {
        this.redirectUrl = params['redirect'];
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  // Overridden by subclasses whose mobile breakpoint differs
  protected isMobileView(): boolean {
    return window.innerWidth < 768;
  }

  protected promptDelayMs(): number | undefined {
    return undefined;
  }

  signInUser(): void {
    this.signInForm.markAllAsTouched();
    if (this.signInForm.invalid) {
      return;
    }

    this.loading.set(true);
    const { email, password } = this.signInForm.getRawValue() as { email: string; password: string };
    this.subscriptions.push(
      this.authCommonService.authenticate({ email, password }).subscribe({
        next: (user) => {
          this.loading.set(false);
          this.authCommonService.handlePostLogin(user, {
            isMobile: this.isMobileView(),
            redirectUrl: this.redirectUrl,
            promptDelayMs: this.promptDelayMs()
          });
        },
        error: () => {
          this.loading.set(false);
        }
      })
    );
  }
}
